// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2-RSK","image":"Header_image__2_y1r","name":"Header_name__3FHHX","info":"Header_info__2c5pb","infoRow":"Header_infoRow__BZv8W"};